import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./Button.css";

const Button = (props) => {
  return (
    <div className="button-wrapper">
      <Link to={`/${props.link}`}>
        <button className="button">{props.text}</button>
      </Link>
    </div>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/Button/Button.js